module.exports = __webpack_public_path__ + "media/images/lb/566-dc9891b918bcf613002bae62aac89b96.svg";